import React from 'react';
import SavingButton from 'library/components/saving-button';

const IdealInstructionsModal = ({ onComplete, saving }) => (
    <div className="survey-instructions-inner">
        <div className="survey-instructions-left">
            <h1>Optional Part 2</h1>
            <p>{"Nice work! You just completed the first part of The PAIRIN Survey. Don't worry. It gets easier from here."}</p>
            <p>{"The second part of the survey is optional. In it, you can review/change your selections from part one in the left column and update the right column for how you'd want to be in a perfect world. To make things easy for you, we'll pre-populate this section with your results from the first part."}</p>
            <blockquote>{'Click the "Start part 2" button below to get started or the "skip" button to submit your survey.'}</blockquote>
            <SavingButton saving={saving} onClick={()=>onComplete('complete')}>Skip</SavingButton>
            <SavingButton saving={saving} onClick={()=>onComplete('ideal')}>Get Started</SavingButton>
        </div>
        <div className="survey-instructions-right">
            <img src="https://assets.pairin.com/production/survey/stack-ideal.gif" />
        </div>
    </div>
)

export default IdealInstructionsModal;
